// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sq7Oc","badges":"styles_badges__1mKHY"};